import { structureTreeTableService } from '../services/structure/structure-treetable.service.js'

export const useBusinessStructureStore = defineStore('business-structure', {
  state: () => ({
    /**
     * Tree table nodes data
     */
    nodeTree: [],
    /**
     * Current Working
     */
    workingNode: null,

    /**
     * Business Area
     */
    businessAreas: [],

    /**
     * Track if the `type` field has a validation error
     */
    validationErrors: {
      name: false,
    },
  }),
  getters: {
    isValidBusinessArea: ({ workingNode, validationErrors }) => {
      if (!workingNode)
        return false

      const { data } = workingNode

      return (
        // Ensure name is valid and has no validation errors
        !!data.name
        && !validationErrors.name
        // Responsible must be present
        && !!data.responsible
        // Type must be present
        && !!data.businessAreaType
      )
    },

    getWorkingNode: ({ workingNode }) => {
      return workingNode
    },
    getWorkingNodeData: ({ workingNode }) => {
      return workingNode.data
    },
    getWorkingNodeParent: ({ workingNode }) => {
      return workingNode.parent
    },

    /**
     * Return business area to use on select
     *
     * @param state
     * @returns {Array} Return array of business area
     */
    getBusinessAreaForSelect: state =>
      state.businessAreas.map(area => ({
        label: area.name,
        value: area._id,
      })),

    getBusinessAreaOption: state => value =>
      state.businessAreas
        .map(area => ({
          label: area.name,
          value: area._id,
        }))
        .find(area => area.value === value),

    getBusinessAreaOptionByLabel: state => label =>
      state.businessAreas
        .map(area => ({
          label: area.name,
          value: area._id,
        }))
        .find(area => area.label === label),

    businessAreaData: (state) => {
      if (!state.workingNode) {
        return null
      }

      // Transform the data for saving
      return {
        name: state.workingNode.data.name,
        responsible: state.workingNode.data.responsible?.value || null,
        isActive: state.workingNode.data.active,
        businessAreaType:
          state.workingNode.data.businessAreaType?.value || null,
        businessUnit: state.workingNode.businessUnitKey,
        parent: state.workingNode.parent.key,
      }
    },
  },
  actions: {
    /**
     * Add New Business Unit to the Level 1 In the tree
     */
    addBusinessUnit(businessUnit) {
      this.nodeTree.push(businessUnit)
    },

    /**
     * Clear Business Unit working Node
     */
    clearWorkingNode() {
      this.workingNode = null
    },

    /**
     * Set all companies that belongs to tenant admin
     *
     * @param nodeTree
     * @param companyUsers
     */
    setNodeTreeData(nodeTree, companyUsers, tooltipConfig, t) {
      this.nodeTree = structureTreeTableService.updateNodeTreeWithResponsible(
        nodeTree,
        companyUsers,
      )

      this.nodeTree = structureTreeTableService.addTooltipsToNodes(
        this.nodeTree,
        tooltipConfig,
        t,
      )
    },

    /**
     * Set business area
     */
    setBusinessArea(businessArea) {
      this.businessAreas = businessArea
    },

    /**
     * Set data content into property of the working Node
     *
     * @param propertyName
     * @param value
     */
    setWorkingNodeDataProperty(propertyName, value) {
      this.workingNode.data[propertyName] = value
    },
    /**
     * Set working node for edit
     * @param nodeKey
     */
    setWorkingNodeData(nodeKey) {
      const nodeData = structureTreeTableService.findNodeById(
        this.nodeTree,
        nodeKey,
      )
      const businessUnitKey = structureTreeTableService.findFirstNodeParentKey(
        this.nodeTree,
        nodeKey,
      )
      const parent = structureTreeTableService.findParentNode(
        this.nodeTree,
        nodeKey,
      )

      this.workingNode = {
        ...nodeData,
        parent: {
          key: parent ? parent.key : null,
          name: parent ? parent.data?.name : null,
        },
        businessUnitKey,
      }

      return this.workingNode
    },

    /**
     *********************************
     * BUSINESS AREA
     *********************************
     */

    /**
     * Create a new empty business are working  node
     */
    newBusinessArea(parentId) {
      const newNode = structureTreeTableService.newNodeItem({
        name: null,
        responsible: [],
        active: true,
        type: null,
      })

      const parent = structureTreeTableService.findNodeById(
        this.nodeTree,
        parentId,
      )
      const businessUnitKey = structureTreeTableService.findFirstNodeParentKey(
        this.nodeTree,
        parentId,
      )

      this.workingNode = {
        ...newNode,
        parent: {
          key: parent.key,
          name: parent.data.name,
        },
        businessUnitKey,
      }
    },

    /**
     * Save the business area node into the nodeTree parent child node
     */
    saveBusinessArea() {
      if ('key' in this.workingNode) {
        structureTreeTableService.editNode(
          this.nodeTree,
          this.workingNode.key,
          this.workingNode,
        )
      }
      else {
        const newKey = structureTreeTableService.generateRandomId()

        const businessArea = {
          ...this.workingNode,
          key: newKey,
        }

        structureTreeTableService.addNode(
          this.nodeTree,
          businessArea,
          this.workingNode.parent.key,
        )
      }

      this.clearWorkingNode()
    },

    setValidationError(field, hasError) {
      this.validationErrors[field] = hasError
    },
  },
})
